import axios from 'axios';
import { IRecipientModel } from '../Models/Recipient';

export const GetCaregiver = async (caregiverId: string) => {
    try {
        const response = await axios.get(`/caregivers/${caregiverId}/recipients`);
        return response.data;
    } catch (error: any) {
        if (error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}

export const PatchCaregiverRecipients = async (userId: string, recipientsArray: Array<IRecipientModel>) => {
    try {
        let caregiver = {
            caregiverId: userId,
            recipients: recipientsArray,
        }
        return await axios.patch(`/caregivers/${userId}/recipients`, caregiver);
    } catch (error: any) {
        if (error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
};

export const PutCaregiver = async (caregiver: any) => {
    try {
        await axios.put(`/caregivers/${caregiver.caregiverId}`, caregiver);
    } catch (error: any) {
        if (error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
};